import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useClientByIdQuery, usePaymentMethodQuery } from 'api';

export const usePricingRules = () => {
  const [modalState, setModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data: clientDetails = {} }: Record<string, any> = useClientByIdQuery({ id });
  const { data: paymentMethodData = [] } = usePaymentMethodQuery();

  const paymentMethod = useMemo(() => {
    return paymentMethodData.find((_method: any) => _method.id === clientDetails.paymentMethodId) || {};
  }, [clientDetails, paymentMethodData]);

  const onModalStateChange = useCallback(() => setModalState((prevState) => !prevState), []);

  return {
    modalState,
    clientDetails,
    paymentMethod,
    onModalStateChange,
  };
};
